import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  childContainer: {
    backgroundColor: "#EDFFF8 !important",
  },
  container: {
    backgroundColor: theme.palette.background.white,
    height: "fit-content",
    width: "95%",
    borderRadius: 8,
    padding: theme.spacing(5, 7),
    paddingBottom: 0,
    position: "relative",
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), -4px 0px 4px rgba(0, 0, 0, 0.05)",
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  innerContainer: {
    height: "100%",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.background.darkGray,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.background.darkGray,
    },
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    padding: theme.spacing(4, 0),
  },
  buttonPrimary: {
    background: "#2A6565",
    textTransform: "capitalize",
    width: 80,
    height: 42,
    marginRight: 15,
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#2A6565",
      color: theme.palette.Primary.light,
    },
  },
  buttonSecondary: {
    color: "#2A6565",
    borderColor: "#2A6565",
    textTransform: "capitalize",
    width: 80,
    height: 42,
    "&:hover": {
      borderColor: "#2A6565",
      backgroundColor: "#2A6565",
      color: "#FFF",
    },
    marginRight: theme.spacing(5),
  },
  topContainer: {
    "& .MuiGrid-container > .MuiGrid-container > .MuiBox-root > .MuiAutocomplete-root > .MuiFormControl-root > .Mui-focused":
      {
        color: "#686868 !important",
      },
    "& .MuiGrid-container > .MuiGrid-container > .MuiBox-root > .MuiStack-root > .MuiFormControl-root > .Mui-focused":
      {
        color: "#686868 !important",
      },
    "& .MuiGrid-container > .MuiGrid-container > .MuiBox-root > .MuiStack-root > .MuiFormControl-root > .MuiInputBase-root > .MuiOutlinedInput-notchedOutline":
      {
        borderColor: "#686868",
      },
  },
  contain: {
    margin: theme.spacing(3, 0),
    display: "flex",
    flexDirection: "column",
  },
  bottomContainer: {
    maxWidth: 700,
    marginTop: theme.spacing(5),
  },
  previewTitle: {
    marginBottom: theme.spacing(3),
  },
  previewItem: {
    margin: theme.spacing(1, 0),
    fontSize: 15,
  },
  secondResultContainer: {
    paddingLeft: `${theme.spacing(4)} !important`,
    marginLeft: theme.spacing(4),
    borderLeft: `solid 1px ${theme.palette.Other.stroke}`,
  },
  textAreaContainer: {
    height: "fit-content",
  },
  backContainer: {
    color: "#387A8A",
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: theme.spacing(3, 0),
  },
  textField: {
    width: "66%",
    "& label.Mui-focused": {
      color: theme.palette.Primary.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.Primary.main,
    },
    "& .MuiInput-root:hover::before": {
      borderWidth: 1,
      borderBottomColor: theme.palette.Primary.main,
    },
    "& .MuiFilledInput-root:hover::before": {
      borderBottomColor: theme.palette.Primary.main,
    },
    "& .MuiFilledInput-underline:after": {
      borderColor: theme.palette.Primary.main,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.Primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.Primary.main,
      },
      "&.Mui-focused fieldset": {
        borderWidth: 2,
        borderColor: theme.palette.Primary.main,
      },
    },
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& .css-czrb7a-MuiFormLabel-root-MuiInputLabel-root,.css-kyi7ki-MuiFormLabel-root-MuiInputLabel-root.Mui-focused":
      {
        color: theme.palette.Primary.main,
      },
  },
  switchColorInactive: {
    height: "40px",
    width: "60px",
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "white",
    },
    "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
      backgroundColor: "green !important",
    },
    "& .MuiSwitch-track": {
      borderRadius : '10px'
    },
    "& .MuiSwitch-switchBase > .MuiSwitch-thumb": {
      height: "20px",
      width: "20px"
    },
  },
  tableContainer: {
    padding: 0,
    maxHeight: "calc(100% - 100px)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    background: theme.palette.background.white,
    marginTop: 20,
    overflow: "auto",
  },
  tableInnerContainer: {
    maxHeight: "100%",
  },
  link: {
    cursor: "pointer",
  },
  searchTextContainer: {
    height: 38,
    minHeight: 34,
    padding:4,
    borderRadius:10,
    backgroundColor: theme.palette.background.white,
    "& .MuiTextField-root.MuiFormControl-root-MuiTextField-root":{
        height: 48
    }
},
headerCell: {
  height: 70,
  fontSize: 14,
  fontWeight: 600,
  padding: theme.spacing(1),
  color: "black",
  backgroundColor: "#BAC6C6 !important",
  "&:first-child": {
    paddingLeft: theme.spacing(4),
  },
  "&:last-child": {
    paddingRight: theme.spacing(4),
  },
},
}));

export default useStyles;
